import React from "react";
import { useParams } from "react-router-dom";
import WithoutAuthLayout from "../routeProtector/withoutAuth";

const ResetPassword = () => {
  let { token } = useParams();
  
  return <div>dadhahgdagh {token}</div>;
};

export default WithoutAuthLayout(ResetPassword);
